<template>
  <section>
    <b-row>
      <!-- Lista de periodos y paginación -->
      <b-col
        xl="3"
        lg="4"
        md="4"
      >
        <b-card>
          <div class="text-center">
            <h4>Periodos disponibles</h4>
          </div>

          <!-- Lista de periodos -->
          <div class="pt-75">
            <b-skeleton-wrapper :loading="loader">
              <!-- Loader -->
              <template #loading>
                <b-skeleton
                  v-for="cont in perPage"
                  :key="cont"
                  width="100%"
                  type="button"
                  class="mb-50"
                />
              </template>
              <!-- Lista de periodos -->
              <b-button
                v-for="item in paginateItems"
                :key="item.id"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                :variant="idSelected === item.id ? 'primary' : 'flat-secondary'"
                class="mb-50 text-left"
                block
                @click="idSelected = item.id"
              >
                <b>{{ item.clave }}</b> <small>({{ item.temp_nombre }})</small>
              </b-button>
            </b-skeleton-wrapper>
          </div>

          <hr>

          <!-- Paginación de periodos -->
          <div>
            <b-skeleton-wrapper :loading="loader">
              <!-- Loader -->
              <template #loading>
                <b-skeleton
                  width="100%"
                  type="button"
                />
              </template>
              <!-- Paginación -->
              <b-pagination
                v-model="currentPage"
                :total-rows="periodos.length"
                :per-page="perPage"
                hide-goto-end-buttons
                align="center"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </b-skeleton-wrapper>
          </div>

          <!-- Agregar nuevo periodo -->
          <div>
            <b-skeleton-wrapper :loading="loader">
              <!-- Loader -->
              <template #loading>
                <b-skeleton
                  class="mt-1"
                  width="100%"
                  type="button"
                />
              </template>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                block
                @click="idToEdit = null; modalShow = true"
              >
                Agregar nuevo periodo
              </b-button>
            </b-skeleton-wrapper>
          </div>
        </b-card>
      </b-col>
      <!-- Detalles de periodo seleccionado -->
      <b-col
        xl="9"
        lg="8"
        md="8"
      >
        <b-skeleton-wrapper :loading="loader">
          <template #loading>
            <b-skeleton
              height="10em"
            />
          </template>
          <detalle-periodo
            :item="itemSelected"
            @will-edit="idToEdit = $event; modalShow = true"
          />
        </b-skeleton-wrapper>
      </b-col>
    </b-row>

    <!-- Modal para crear/editar periodos -->
    <modal-periodo
      v-model="modalShow"
      :to-edit="toEdit"
      @update-list="loadPeriodos(); modalShow = false"
    />

  </section>
</template>

<script>
import { ref, onMounted, computed } from '@vue/composition-api'
import {
  BRow,
  BCol,
  BSkeletonWrapper,
  BSkeleton,
  BPagination,
  BCard,
  BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { paginateArray } from '@core/utils/utils'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useServicioEscolarCatalogos } from '@/views/campus/servicio-escolar/useServicioEscolar'

import DetallePeriodo from './components/periodos/DetallePeriodo.vue'
import ModalPeriodo from './components/periodos/ModalPeriodo.vue'

export default {
  components: {
    BRow,
    BCol,
    BSkeletonWrapper,
    BSkeleton,
    BPagination,
    BCard,
    BButton,

    DetallePeriodo,
    ModalPeriodo,
  },
  directives: {
    Ripple,
  },
  setup() {
    const toast = useToast()
    const { periodoOptionsPromise } = useServicioEscolarCatalogos()
    const periodos = ref([])
    const idSelected = ref(null)
    const idToEdit = ref(null)
    const loader = ref(false)
    const currentPage = ref(1)
    const perPage = ref(5)
    const modalShow = ref(false)

    const paginateItems = computed(() => paginateArray(periodos.value, perPage.value, currentPage.value))
    const toEdit = computed(() => periodos.value.find(item => item.id === idToEdit.value) || {})
    const itemSelected = computed(() => periodos.value.find(item => item.id === idSelected.value) || {})

    const loadPeriodos = () => {
      loader.value = true
      periodoOptionsPromise().then(response => {
        loader.value = false
        periodos.value = response || []
      }, error => {
        loader.value = false
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error en petición [Carga de periodos]',
            text: error,
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        },
        { timeout: 10000 })
      })
    }

    onMounted(() => {
      loadPeriodos()
    })

    return {
      // Data
      periodos,
      paginateItems,
      idSelected,
      itemSelected,
      idToEdit,
      toEdit,
      modalShow,

      // Functions
      loadPeriodos,

      // Loaders
      loader,

      // Pagination
      currentPage,
      perPage,
    }
  },
}
</script>
